import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import ModelHome from "./pages/ModelHome";
import ModelApp from "./pages/ModelApp";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/deby" replace />} />
        <Route path="/:modelName" element={<ModelHome />} />
        {/* preferred path */}
        <Route path="/:modelName/a/:album" element={<ModelApp />} />
        {/* compatibility with /:modelName/:album */}
        <Route path="/:modelName/:album" element={<ModelApp />} />
        <Route path="*" element={<div style={{ padding: 24 }}>Not found</div>} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
